<template>
  <page-view>
    <template #header>
      <Header v-if="!isMobileBreakpoint" />
    </template>

    <template #content>
      <ErrorState v-if="errorState" />
      <component
        v-else
        :is="currentComponent"
        :component-data="componentData"
        :has-any-video-in-filter="hasAnyVideoInFilter"
      />
    </template>
  </page-view>
</template>

<script>
import Plays from './screens/Plays'
import Devices from './screens/Devices'
import Browsers from './screens/Browsers'
import Locations from './screens/Locations'
import Reference from './screens/Reference'
import UTM from './screens/UTM'
import Lives from './screens/Lives'
import BestTimes from './screens/BestTimes'
import Users from './screens/Users'
import Retention from './screens/Retention'
import Resume from './screens/Resume'
import VideoComparer from './screens/VideoComparer'
import Bandwidth from './screens/Bandwidth'
import ErrorState from './screens/ErrorState/index.vue'
import { mapMutations, mapState } from 'vuex'
import { subDays } from 'date-fns'

export default {
  name: 'AnalyticsV3',
  components: {
    PageView: () => import('./components/PageView.vue'),
    Header: () => import('./components/header.vue'),
    ErrorState,
  },
  data: () => ({
    hasAnyVideoInFilter: false,
    selectedVideos: [],
  }),
  computed: {
    ...mapState({
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
    }),
    ...mapState('analytics', ['filterDataRange', 'errorState']),
    componentData() {
      const start = this.filterDataRange?.start || new Date()
      const end = this.filterDataRange?.end || new Date()
      return {
        selectedVideos: this.selectedVideos,
        dateRange: [start, end],
      }
    },
    currentComponent() {
      const map = {
        AnalyticsV3VideoComparer: VideoComparer,
        AnalyticsV3Plays: Plays,
        AnalyticsV3Retention: Retention,
        AnalyticsV3Devices: Devices,
        AnalyticsV3Browsers: Browsers,
        AnalyticsV3Locations: Locations,
        AnalyticsV3Reference: Reference,
        AnalyticsV3UTM: UTM,
        AnalyticsV3Lives: Lives,
        AnalyticsV3BestTimes: BestTimes,
        AnalyticsV3Users: Users,
        AnalyticsV3Resume: Resume,
        AnalyticsV3Bandwidth: Bandwidth,
      }
      return map[this.$route.name] || 'Resume'
    },
  },
  methods: {
    ...mapMutations('analytics', ['UPDATE_FILTER_DATA_RANGE']),
    handleAnalyticsPageScroll() {
      const path = this.$route.path
      const isAnalytics = /(analyticsv3)/i.test(path)

      const $html = document.querySelector('html')
      const hasClass = $html.classList?.contains('analytics--page-scroll')

      if (isAnalytics) {
        if (hasClass) return
        $html.classList.add('analytics--page-scroll')
      } else {
        if (!hasClass) return
        $html.classList.remove('analytics--page-scroll')
      }
    },
  },
  mounted() {
    this.UPDATE_FILTER_DATA_RANGE({
      start: subDays(new Date(), 31),
      end: subDays(new Date(), 1),
    })
  },
  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler() {
        this.handleAnalyticsPageScroll()
      },
    },
  },
  beforeDestroy() {
    this.handleAnalyticsPageScroll()
  },
}
</script>
<style lang="scss">
.analytics--page-scroll {
  height: 100%;
  overflow: hidden;
  body {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    height: 100%;
    #app {
      height: 100%;
      .v-main {
        height: 100%;
      }
      nav {
        z-index: 20 !important;
      }
    }
  }
}
</style>
